import { render, staticRenderFns } from "./ElementCommentPeriodTableColumn.vue?vue&type=template&id=b7332992&scoped=true"
import script from "./ElementCommentPeriodTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCommentPeriodTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementCommentPeriodTableColumn.vue?vue&type=style&index=0&id=b7332992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7332992",
  null
  
)

export default component.exports